import { MediaUpload, VideoUpload } from "@aqar-app/react-ui";
import React, { useEffect, useRef, useState } from "react";
import { dispatchCtxChange, dispatchCtxUiEvent } from "@/components/add-v2/ui";
import { uploadImg } from "@/components/media-upload/mediaUpload";
import { useAuthState } from "@/contexts/auth/auth.provider";
import Config from "@/common/config";
import { getDynamicLabel } from "@/components/add-v2/validate";

import css from "./.module.scss";
import { useLazyQuery } from "@apollo/client";
import { GET_VIDEO_ACCESS } from "@/graphql/queries/listing";
import { VIDEO_ORIENTATION } from "@/common/constants";
export function VideoUploadComponent({
  rules,
  label,
  dynamic,
  value,
  name,
  ctxRef,
  mime,
  nested,
  ...props
}) {
  const { token } = useAuthState();
  const rootRef = useRef(null);
  const [src, setSrc] = useState([]);

  const [getVideoAccess] = useLazyQuery(GET_VIDEO_ACCESS, {
    context: { token },
  });

  useEffect(() => {
    Promise.all(
      value?.map(async (item) => {
        const video = item?.video || item;
        return await getVideoAccess({
          variables: {
            fileName: `${video}/${video}_${VIDEO_ORIENTATION}.mp4`,
          },
        }).then((res) => {
          const videoURL = res?.data?.User?.getVideoAccess || {};
          return { name: video, src: videoURL };
        });
      }) || [],
    ).then((videos) => {
      if (!videos.length) return;
      setSrc(videos);
    });
  }, [value]);
  return (
    <div ref={rootRef} className={css.picker}>
      <VideoUpload
        src={src}
        placeholder={
          label?.dynamic ? getDynamicLabel({ label, ctx }) : label?.ar
        }
        onStart={() => {
          dispatchCtxUiEvent(rootRef.current, {
            type: "loading",
            value: true,
          });
        }}
        asyncUpload={async (file) => {
          const f = await uploadImg(file, token, "videos", "video", "mp4");

          return {
            fileName: f.fileName.replace(".mp4", ""),
          };
        }}
        onChange={(files) => {
          dispatchCtxUiEvent(rootRef.current, {
            type: "loading",
            value: false,
          });

          dispatchCtxChange(document.body, {
            value: files,
            name,
            nested,
          });
        }}
        mime={mime}
        {...props}
      />
    </div>
  );
}
